var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcBlueCamera(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 23.2,
    viewBox: "0 0 29 23.2",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-17.2%",
    y: "-17.2%",
    width: "134.5%",
    height: "143.1%",
    filterUnits: "objectBoundingBox",
    id: "gh4dnuxtua"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.141838001 0 0 0 0 0.155111414 0 0 0 0 0.191009964 0 0 0 1 0",
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#gh4dnuxtua)",
    fill: "#5C88FF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.533 4.035h-3.026l-1.671-2.522C20.206.567 19.102 0 17.967 0h-6.934C9.898 0 8.795.567 8.164 1.513l-1.67 2.522H3.466A3.457 3.457 0 0 0 0 7.502v12.23A3.457 3.457 0 0 0 3.467 23.2h22.066A3.457 3.457 0 0 0 29 19.733V7.503a3.457 3.457 0 0 0-3.467-3.468zM14.5 20.363a7.816 7.816 0 0 1-7.817-7.817c0-4.319 3.499-7.786 7.817-7.786a7.816 7.816 0 0 1 7.817 7.817c0 4.287-3.499 7.786-7.817 7.786zM25.091 8.921H23.705a1.026 1.026 0 0 1 0-2.049h1.26c.568-.032 1.04.41 1.072.977a.998.998 0 0 1-.946 1.072z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5 8.227a4.359 4.359 0 0 0-4.35 4.35c0 2.396 1.954 4.319 4.35 4.319a4.359 4.359 0 0 0 4.35-4.35c0-2.396-1.954-4.319-4.35-4.319z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcBlueCamera);
export default __webpack_public_path__ + "static/media/ic_blue_camera.49ba1de0cc8010e5cbf624e664015d56.svg";
export { ForwardRef as ReactComponent };